import { AppState } from '@/redux/helper';

// eslint-disable-next-line import/prefer-default-export
export const selectIsAnimalAlertPopoverOpen = (state: AppState) => state.settings.animalAlertPopover.isOpen;
